<template>
    <div class="general-popup-wrapper">
        <div class="overlay"></div>
        <div class="center-popup">
            <div class="popup with-animation">
                <div class="popup-top primary-c-bg">
                    <img src="img/logo.png" :alt="settings.title">
                </div>
                <div class="popup-content">
                    <p>Welkom, {{ user.first_name }}!</p>
                    <span>Stel je jezelf even voor aan de rest van de groep?</span>
                    <div class="input-wrapper">
                        <input type="text" v-model="title" placeholder="Hoi! Mijn naam is --- en ik ben ---">
                        <textarea v-model="body" placeholder="Ik zou mijzelf omschrijven als ---"></textarea>
                        <div class="general-button" @click="introduce">Stel jezelf voor</div>
                        <span class="dismiss-introduction" @click="dismiss">Nee bedankt, ik doe het liever later</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js'

    export default {
        mixins:[Global],

        data() {
            return {
                title: '',
                body: ''
            }
        },

        methods: {
            introduce() {
                if (this.title !== '') {
                    let data = {
                        'title': this.title,
                        'body': this.body,
                    };

                    this.$store.dispatch(
                        {
                            type: 'introduced',
                            data: {
                                payload: data,
                            }
                        }
                    );
                }
            },

            dismiss() {
                this.$store.dispatch('dismissIntroduction');
            }
        },
    }
</script>

<style lang="scss" scoped>
    .general-popup-wrapper {
        .overlay {
            background: rgba(57, 61, 66, 0.7);
        }

        .center-popup {
            .popup {
                display: flex;
                flex-direction: column;
                background: none;
                //overflow: hidden;

                .popup-top {
                    border-radius: 10px 10px 0 0 !important;
                    padding: 0;
                    height: 83px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        max-width: 50%;
                        max-height: 50%;
                    }
                }

                .popup-content {
                    flex: 1;
                    padding: 50px;
                    background: #f5f5f5;
                    border-radius: 0 0 10px 10px;

                    p {
                        font-size: 20px;
                        line-height: 28px;
                        font-weight: 900;
                    }

                    span {
                        margin-top: 10px;
                        display: block;
                        color: #6f6f6f;
                        font-size: 15px;

                        &.dismiss-introduction {
                            color: #9e9e9e;
                            font-size: 12px;
                            cursor: pointer;
                            text-decoration: underline;
                        }
                    }

                    .general-button {
                        margin-bottom: 15px;
                    }

                    .input-wrapper {
                        max-width: 80%;
                        margin: auto;

                        input, textarea {
                            color: rgba(0, 0, 0, 0.7);

                            &::placeholder {
                                color: rgba(0, 0, 0, 0.4);
                            }
                        }

                        input {
                            margin-top: 30px;
                            background: none;
                        }

                        textarea {
                            height: 100px;
                            background: none;
                        }
                    }
                }
            }
        }
    }
</style>